import { Link } from 'react-router-dom';
import PageWrapper from '@/components/layout/PageWrapper';
import { Button } from '@/components/common/Button/Button';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';

const NotFound = () => {
  return (
    <PageWrapper
      title="404 - Page Not Found | Cobalt"
      description="The page you're looking for doesn't exist or has been removed."
      noIndex={true}
    >
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />
        <main className="flex-1 pt-16">
          <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] bg-[var(--background)] text-center px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-3xl w-full mx-auto">
              <h1 className="text-[120px] md:text-[200px] font-extrabold tracking-tight text-gray-900 leading-none">
                404
              </h1>
              <p className="text-base md:text-lg text-gray-600 max-w-md mx-auto mt-4 mb-8 md:mb-10">
                The page you're looking for doesn't exist or has been removed. Please go back to the homepage.
              </p>
              <Link to="/">
                <Button
                  variant="solid"
                  color="primary"
                  size="lg"
                  className="font-medium px-6 md:px-8 py-3 text-base md:text-lg"
                >
                  Go Back Home
                </Button>
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </PageWrapper>
  );
};

export default NotFound;